/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.SpaceEligibilityRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './SpaceEligibilityRpc';
import * as Queries from './SpaceEligibilityRpc.dfc.new';
import type { AdditionalContextArgs } from './SpaceEligibilityRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseListCreatableSpacesQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.ListCreatableSpacesResponseType>,
    References.ListCreatableSpacesRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'listCreatableSpaces',
            References.ListCreatableSpacesResponseType
          >
        : References.ListCreatableSpacesResponseType)
    | undefined;
};

export function useListCreatableSpacesQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.ListCreatableSpacesResponseType>,
    References.ListCreatableSpacesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListCreatableSpacesQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.LIST_CREATABLE_SPACES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listCreatableSpaces: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListCreatableSpacesQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListCreatableSpacesQueryReturn<T>;
}

type UseListCreatableSpacesLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.ListCreatableSpacesResponseType>,
    References.ListCreatableSpacesRequestType,
    T extends true
      ? Record<
          'listCreatableSpaces',
          References.ListCreatableSpacesResponseType
        >
      : References.ListCreatableSpacesResponseType
  >;

export function useListCreatableSpacesLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.ListCreatableSpacesResponseType>,
    References.ListCreatableSpacesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListCreatableSpacesLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.LIST_CREATABLE_SPACES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            listCreatableSpaces: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseListCreatableSpacesLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseListCreatableSpacesLazyQueryReturn<T>;
}

type UseListCreatableSpacesSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.ListCreatableSpacesResponseType>,
    References.ListCreatableSpacesRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'listCreatableSpaces', References.ListCreatableSpacesResponseType>
    : References.ListCreatableSpacesResponseType;
};

export function useListCreatableSpacesSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.ListCreatableSpacesResponseType>,
    References.ListCreatableSpacesRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseListCreatableSpacesSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.LIST_CREATABLE_SPACES_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            listCreatableSpaces: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseListCreatableSpacesSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseListCreatableSpacesSuspenseQueryReturn<T>;
}
